module.exports = __webpack_public_path__ + "static/media/icon_list_thumbnail_current.93460d40.svg";